angular
	.module 'App.Service'
	.service 'Base64Service', ->
		encode: (str) -> btoa(str)
		decode: (str) -> atob(str)
